<template>
  <ul
    class="dropdown-menu"
    v-on="$listeners"
    :style="{ '--dropdown-menu-height': maxHeight ? `${maxHeight}px` : '300px' }"
  >
    <li v-show="options.length === 0 && !hideNoResults">
      <span>No results</span>
    </li>

    <li
      v-for="({ value, label, icon, marker }, index) in options"
      :key="value"
      :class="{ active: activeValue === value, focus: index === focus }"
      @click.stop.prevent="selectItem(value)"
    >
      <align justify="space-between">
        <align>
          <icon v-if="icon" :name="icon" class="icon" />
          <span>{{ label }}</span>
        </align>

        <pro-label v-if="marker">{{ marker }}</pro-label>
      </align>
    </li>
  </ul>
</template>

<script>
import ProLabel from './ProLabel';
import Align from './Align';
import Icon from './Icon';

export default {
  components: {
    Align,
    Icon,
    ProLabel,
  },

  props: {
    options: Array,
    activeValue: [String, Number, Boolean],
    hideNoResults: Boolean,
    focus: Number,
    maxHeight: Number,
  },

  methods: {
    selectItem(value) {
      this.$emit('select', value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.dropdown-menu {
  line-height: 1.5;

  li {
    padding: $gp * .75 $gp;

    span {
      @include ellipsis;
    }

    .icon {
      color: $color-gray-5;
    }

    &:hover,
    &.focus {
      background-color: var(--theme-highlight);
    }

    &:active {
      background-color: var(--theme-active);
    }

    &.active {
      background-color: var(--theme-active);
    }
  }
}
</style>
